export function encodeUid(...ids: string[]): string {
  return JSON.stringify(ids);
}

export function decodeUid(uid: string): string[] {
  return JSON.parse(uid);
}
